"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToExcelZipDesign = exports.exportToExcel = void 0;
/* eslint-disable no-undef */
var ReportUtils_1 = require("@cck/common/dist/data/DesignEvaluation/ReportUtils");
var ExcelJS = __importStar(require("exceljs"));
var file_saver_1 = require("file-saver");
var jszip_1 = __importDefault(require("jszip"));
var lodash_1 = __importDefault(require("lodash"));
var StorageManager_1 = require("../storage/StorageManager");
var ExcelExporter_1 = require("./ExcelExporter");
var exportToExcel = function (staffs, evaluation) { return __awaiter(void 0, void 0, void 0, function () {
    var workbook, evaluationDefs, sheetOptions, testInfoSheet, fileInfoSheet, rcmModificationSheet, buffer, fileType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                workbook = new ExcelJS.Workbook();
                workbook.creator = 'CCKSolution';
                evaluationDefs = (0, ReportUtils_1.getDesignEvaluationDefs)();
                sheetOptions = { views: [{ showGridLines: false, zoomScale: 85 }] };
                testInfoSheet = workbook.addWorksheet('설계평가', sheetOptions);
                (0, ExcelExporter_1.writeWorksheet)(evaluationDefs.DesignEvaluation, testInfoSheet, evaluation);
                fileInfoSheet = workbook.addWorksheet('증빙문서', sheetOptions);
                (0, ExcelExporter_1.writeWorksheet)((0, ExcelExporter_1.updateFileInfoRows)(staffs, evaluationDefs.FileInfo, evaluation), fileInfoSheet, evaluation);
                rcmModificationSheet = workbook.addWorksheet('RCM수정사항', sheetOptions);
                rcmModificationSheet.properties.defaultRowHeight = 40;
                (0, ExcelExporter_1.writeWorksheet)(evaluationDefs.RcmModification, rcmModificationSheet, evaluation);
                return [4 /*yield*/, workbook.xlsx.writeBuffer()];
            case 1:
                buffer = _a.sent();
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                return [2 /*return*/, new Blob([buffer], { type: fileType })];
        }
    });
}); };
exports.exportToExcel = exportToExcel;
function downloadFilesWithoutRecord(zip, evaluation) {
    return __awaiter(this, void 0, void 0, function () {
        var baseFilePath, files, filePath, fileBlob;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baseFilePath = "\uC124\uACC4\uD3C9\uAC00/".concat(evaluation.base.name, "/").concat(evaluation.controlId);
                    files = evaluation.content.files;
                    if (!(files.population && !lodash_1.default.isEmpty(files.population.name))) return [3 /*break*/, 2];
                    filePath = "".concat(baseFilePath, "/").concat(files.population.name);
                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(filePath)];
                case 1:
                    fileBlob = _a.sent();
                    zip.file(files.population.name, fileBlob, { binary: true });
                    _a.label = 2;
                case 2: return [4 /*yield*/, Promise.all(lodash_1.default.map(lodash_1.default.concat(lodash_1.default.values(files.evidence), lodash_1.default.values(files.extra)), function (file) { return __awaiter(_this, void 0, void 0, function () {
                        var filePath, fileBlob;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    filePath = "".concat(baseFilePath, "/").concat(file === null || file === void 0 ? void 0 : file.name);
                                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(filePath)];
                                case 1:
                                    fileBlob = _a.sent();
                                    zip.file(file === null || file === void 0 ? void 0 : file.name, fileBlob, { binary: true });
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function exportToExcelZipDesign(staffs, evaluations) {
    return __awaiter(this, void 0, void 0, function () {
        var zip;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    zip = new jszip_1.default();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(evaluations, function (evaluation) { return __awaiter(_this, void 0, void 0, function () {
                            var subZip;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        subZip = zip.folder(evaluation.controlId);
                                        if (!subZip) return [3 /*break*/, 2];
                                        subZip.file("(".concat(evaluation.base.name, ")(").concat(evaluation.controlId, ")(\uBCF4\uACE0\uC11C readonly) \uBCF4\uACE0\uC11C.xlsx"), (0, exports.exportToExcel)(staffs, evaluation), {
                                            binary: true
                                        });
                                        return [4 /*yield*/, downloadFilesWithoutRecord(subZip, evaluation)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    zip.generateAsync({ type: 'blob' }).then(function (content) {
                        var name = lodash_1.default.get(lodash_1.default.head(evaluations), 'base.name', '설계평가');
                        (0, file_saver_1.saveAs)(content, "".concat(name, "_\uBCF4\uACE0\uC11C.zip"));
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.exportToExcelZipDesign = exportToExcelZipDesign;
//# sourceMappingURL=DesignExcelExporter.js.map